import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../redux/store';
import { toggleLanguage, setLanguage } from '../redux/slices/languageSlice';

export const useLanguage = () => {
  const dispatch = useDispatch();
  const { language, translations } = useSelector((state: RootState) => state.language);

  const handleToggleLanguage = () => {
    dispatch(toggleLanguage());
  };

  const handleChangeLanguage = (lang: 'en' | 'es') => {
    dispatch(setLanguage(lang));
  };

  return {
    language,
    translations, // Puedes usar esto como 't' en tus componentes
    toggleLanguage: handleToggleLanguage,
    setLanguage: handleChangeLanguage,
  };
};

